import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=1d1b27bf&scoped=true&"
import script from "./copy.vue?vue&type=script&lang=ts&"
export * from "./copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b27bf",
  null
  
)

export default component.exports